import {SimulationParams} from './_models'

export function getPreferentialTradePartners(axiosInstance, iso3: string) {
  return axiosInstance.get(`/get/preferential-trade-partners/${iso3}`)
}

export function runPreferenceLossSimulation(axiosInstance, params: SimulationParams) {
  return axiosInstance.post(`/simulate/preference-loss`, {
    econ: params.econ,
    year: params.year,
    elas_supply: params.elas_supply,
    elas_substitution: params.elas_substitution,
    elas_type: params.elas_type,
    price_effect: 0,
    exclude_bilateral_agreements: params.exclude_bilateral_agreements,
    exclude_group_agreements: params.exclude_group_agreements,
    combine_effects_diversion: true,
  })
}
